import React, { useState } from "react";
import Hackthisfall from "../assets/Hackthisfall.jpg";
import Progate from "../assets/Progate.png";
import MLH1 from "../assets/MLH1.png";
import MLH2 from "../assets/MLH2.png";
import Pythonweek from "../assets/Pythonweek.png";
import Covlab from "../assets/Covlab.png";
import Apscript from "../assets/Apscript.jpg";

function Hackthon(props) {
  const [category, setCategory] = useState("organized");
  const hackathonData = [
    {
      id: 1,
      title: "Hack This Fall",
      type: "organized",
      image: Hackthisfall,
    },
    {
      id: 2,
      title: "Progate Webathon",
      type: "organized",
      image: Progate,
    },
    { id: 3, title: "MLH Build Day (2nd)", type: "won", image: MLH1 },
    { id: 4, title: "MLH Share Day (3rd)", type: "won", image: MLH2 },
    {
      id: 5,
      title: "The Python Week (Top 10)",
      type: "won",
      image: Pythonweek,
    },
    { id: 6, title: "CovLab Global (Top 10)", type: "won", image: Covlab },
    { id: 7, title: "", type: "judged", image: Apscript },
  ];

  const SingleHackathon = (props) => {
    return (
      <div className="col-sm-12 col-md-6">
        <div className="hackathon__image my-5">
          <img src={props.data.image} alt="" />
          <p>{props.data.title}</p>
        </div>
      </div>
    );
  };

  return (
    <div id="hackathons" className="hackathon" data-aos={"fade-right"}>
      <span className="hackathon__span">Hackathons 😎</span>
      <div className="row my-2 projects__title">
        <div
          className={`col-4 my-3 ${
            category === "organized" ? "alive" : null
          }`}
          onClick={() => setCategory("organized")}
        >
          <span>Organized</span>
        </div>
        <div
          className={`col-4 my-3 ${category === "won" ? "alive" : null}`}
          onClick={() => setCategory("won")}
        >
          <span>Won</span>
        </div>
        <div
          className={`col-4 my-3 ${category === "judged" ? "alive" : null}`}
          onClick={() => setCategory("judged")}
        >
          <span>Judged</span>
        </div>
      </div>
      <div className="container">
        <div className="row">
          {hackathonData.map((data) => {
            if (category === "organized" && data.type === "organized") {
              return <SingleHackathon key={data.id} data={data} />;
            } else if (category === "won" && data.type === "won") {
              return <SingleHackathon key={data.id} data={data} />;
            } else if (category === "judged" && data.type === "judged") {
              return <SingleHackathon key={data.id} data={data} />;
            } else {
              return <div></div>;
            }
          })}
        </div>
      </div>
    </div>
  );
}

export default Hackthon;
